import Layout from "../../../../components/layout/Layout";
import React from "react";
import ReportFilter, {DATE_MODE_RANGE} from "../../ReportFilter";
import FilterSidebar from "../../../../components/FilterSidebar";
import {Link} from "react-router-dom";
import Icon from "../../../../components/elements/Icon";
import ReportTab from "./tabs/ReportTab";

const { REPORT_TYPES } = require('../../../../core/constants').default;

export default function () {

    const {
        eventsTabLoaded, eventsTabFilter, filterSidebar, filters,
    } = this.state;
    const { user, isFetching } = this.props;

    return (
        <Layout
            className={"outside-working-hours-report"}
            title={<div>Inside/Outside Working Hours Report</div>}
            headerTitle={<div>Inside/Outside Working Hours Report</div>}
            loading={isFetching}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar displayFilter={filterSidebar}>
                    <ReportFilter
                        onSubmit={this.onEventsTabFilterChange}
                        filters={filters}
                        showDivision
                        dateMode={DATE_MODE_RANGE}
                        insideOutsideSelection
                        showWorkingHoursRange
                        reportType={REPORT_TYPES.find((rt) => rt.link === 'outside-working-hours-report').link}
                    />
                </FilterSidebar>
                <div 
                    className="content"
                    style={{ opacity: isFetching ? 0 : 1 }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div className="section__body">
                                <div className="section__action-bar">
                                </div>
                                <ReportTab
                                    toggleFilterSidebar={() => this.setState({filterSidebar: !filterSidebar})}
                                    eventsTabFilter={eventsTabFilter}
                                    setLoadedState={eventsTabLoaded}
                                    eventsTabLoaded={eventsTabLoaded}
                                />
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    )
}